jQuery(function () {
  jQuery('#bubble-layer_1').css({backgroundPosition: '0px 0px'});
  jQuery('#bubble-layer_2').css({backgroundPosition: '0px 0px'});
  jQuery('#bubble-layer_3').css({backgroundPosition: '0px 0px'});

  jQuery('#bubble-layer_2').animate({
    backgroundPosition: "(-10000px -2000px)"
  }, 240000, 'linear');

  jQuery('#bubble-layer_1').animate({
    backgroundPosition: "(-10000px -2000px)"
  }, 120000, 'linear');

  jQuery('#bubble-layer_3').animate({
    backgroundPosition: "(-10000px -2000px)"
  }, 480000, 'linear');

  $(document).ready(function(){
    $(".menubutton").click(function(){
      $('.left_column').toggleClass('open');
    });
  });
  $(document).ready(function(){
    $(".home-btn").click(function(){
      $('.mainmenu').toggleClass('open');
    });
  });
});